import Vue from "vue";
import VueI18n from "vue-i18n";
import enMessages from "@/locales/en.json";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "en", // set locale
  messages: { en: enMessages }, // set locale messages
  fallbackLocale: 'en'
});

export default i18n;
